import { gql } from "@apollo/client";

//get current date data api call query

export const GetTodayPaymentBalance = gql`
  query GetTodayPaymentBalance(

  $page: Int,

  $pageSize: Int,

  $search: String,

  $paginate: Boolean

) {

  getTodayPaymentBalance(

    page: $page,

    pageSize: $pageSize,

    search: $search,

    paginate: $paginate

  ) {

    success

    error

    message

    totalCount

    totalPages

    currentPage

    hasNextPage

    hasPreviousPage

    data {

      customerCode

      customerName

      repCode

      repName

      status

      creditLimit

      ageOfInvoice

      ndays

      category

      totalBalance

      paymentReceivable

      amountPaid

      outstandingAmount

      createdBy
 
      invoices {

        id

        invoiceNumber

        soDate

        balance

        status

        paymentStatus

        partialPaidAmount

        remainingAmount

        remarks

        uploadedAt

        receiptNumber

        receiptDate

      }
 
      checkins {

        id

        checkInTime

        checkinLocationLat

        checkinLocationLng

        visitDate

      }
 
      checkouts {

        id

        checkOutTime

        checkoutLocationLat

        checkoutLocationLng

        duration

        remarks

        orderType

        orderNumber

        visitDate

      }

    }

  }

}
`;


export const getCurrentPaymentBalance = gql`
  query GetPaymentBalance(
    $page: Int
    $pageSize: Int
    $search: String
    $paginate: Boolean
  ) {
    allPaymentBalance(
      page: $page
      pageSize: $pageSize
      search: $search
      paginate: $paginate
    ) {
      success
      message
      totalCount
      totalPages
      currentPage
      hasNextPage
      hasPreviousPage
      data {
        customerCode
        customerName
        repCode
        repName
        creditLimit
        ageOfInvoice
        ndays
        category
        totalBalance
        paymentReceivable
        amountPaid
        outstandingAmount
        status
        id
        createdAt
        createdBy
        invoices {
          id
        }
        checkins {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }
        checkouts {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          remarks
          orderType
          orderNumber
          visitDate
        }
      }
    }
  }
`;

export const getPaymentBalanceByCurrentDate = gql`
  query GetPaymentBalanceByCurrentDate(
    $page: Int
    $pageSize: Int
    $search: String
  ) {
    getPaymentBalanceByCurrentDate(
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const getPaymentBalanceById = gql`
query GetPaymentBalance($id: ID!) {
    getPaymentBalance(id: $id) {
      success
      error
      message
      data {
        customerCode
        customerName
        repCode
        repName
        creditLimit
        ageOfInvoice
        ndays
        category
        totalBalance
        paymentReceivable
        amountPaid
        outstandingAmount
        status
        id
        invoices {
          id
          receiptNumber
          receiptDate
          invoiceNumber
          soDate
          balance
          partialPaidAmount
          remainingAmount
          remarks
          status
          paymentStatus
        }
 
        checkins {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }
 
        checkouts {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          remarks
          orderType
          orderNumber
          visitDate
        }
      }
    }
  }`

// export const getPaymentBalanceById = gql`
//   query GetPaymentBalance($id: ID!) {
//     getPaymentBalance(id: $id) {
//       success
//       error
//       message
//       data {
//         customerCode
//         customerName
//         repCode
//         repName
//         creditLimit
//         ageOfInvoice
//         ndays
//         category
//         totalBalance
//         paymentReceivable
//         amountPaid
//         outstandingAmount
//         status
//         id
//         createdBy
//         invoices {
//           id
//           invoiceNumber
//           soDate
//           balance
//           partialPaidAmount
//           remainingAmount
//           remarks
//           status
//           paymentStatus
//         }

//         checkins {
//           id
//           checkInTime
//           checkinLocationLat
//           checkinLocationLng
//           visitDate
//         }

//         checkouts {
//           id
//           checkOutTime
//           checkoutLocationLat
//           checkoutLocationLng
//           duration
//           remarks
//           orderType
//           orderNumber
//           visitDate
//         }
//       }
//     }
//   }
// `;

//get Past date data api call query
export const getPaymentBalanceByPastDate = gql`
  query GetPaymentBalances(
    $page: Int
    $pageSize: Int
    $search: String
    $startDate: Date
    $endDate: Date
    $customers: [String]
    $agents: [String]
  ) {
    getPaymentBalanceByPastDate(
      page: $page
      pageSize: $pageSize
      search: $search
      startDate: $startDate
      endDate: $endDate
      customers: $customers
      agents: $agents
    ) {
      success
      message
      totalCount
      currentPage
      totalPages
      data {
        id
        customerCode
        customerName
        repCode
        repName
        creditLimit

        ageOfInvoice
        ndays

        paymentReceivable
        amountPaid
        outstandingAmount
        category
        totalBalance
        status
        invoices {
          id
        }
        checkins {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }

        checkouts {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          remarks
          orderType
          orderNumber
          visitDate
        }
      }
    }
  }
`;

//Post api call mutation
export const createPaymentBalance = gql`
  mutation CreatePaymentBalance($input: CreatePaymentBalanceInput!) {
    createPaymentBalance(input: $input) {
      success

      error

      message
    }
  }
`;

//Put Api call mutation
export const UpdatePaymentBalance = gql`
  mutation UpdatePaymentBalance($input: UpdatePaymentBalanceInput!) {
    updatePaymentBalance(input: $input) {
      success

      message
    }
  }
`;

//upload excel
export const uploadPaymentBalance = gql`
  mutation UploadPaymentBalanceFile($input: UploadPaymentBalanceFileInput!) {
    uploadPaymentBalanceFile(input: $input) {
      success

      error

      message
    }
  }
`;

//export excel
export const exportPaymentBalances = gql`
  mutation ExportPaymentBalances($startdate: Date!, $enddate: Date!) {
    exportPaymentBalances(startDate: $startdate, endDate: $enddate) {
      success
      message
      fileUrl
    }
  }
`;

//get role api mutation
export const allRoles = gql`
  query allRoles {
    allRoles {
      data {
        id
        role
        description
      }
      success
      error
      message
    }
  }
`;

//get user api mutation
export const allUsers = gql`
  query {
    allUsers {
      id

      employeeName

      employeeCode

      email

      contactNumber

      address

      role {
        id
        role
      }

      department

      profilePicture

      webUse

      mobileUse
    }
  }
`;

//filter payment balance
export const FilterPaymentBalance = gql`
  query filterPaymentBalanceByDate($startdate: Date!, $enddate: Date!) {
    filterPaymentBalanceByDate(startDate: $startdate, endDate: $enddate) {
      success
      message
      error
      data {
        customerCode
        customerName
        repCode
        repName
        totalBalance
        status
        invoices {
          invoiceNumber
          soDate
          balance
        }
        checkins {
          checkInTime
          visitDate
        }
        checkouts {
          checkOutTime
          duration
          visitDate
        }
      }
    }
  }
`;

export const deliveryToPaymentQuery = gql`
  query GetDeliveryById($id: ID!) {
    getDeliveryById(id: $id) {
      success
      error
      message
      data {
        id
        deliveryId
        repCode
        deliveryStatus
        customerName
        customerAddress
        contactPerson
        contactNumber
        paymentMode
        deliveredDate
        deliveryAgent {
          firstName
          lastName
        }
        repName
        repRole
        createdAt
        salesOrder {
          id
          soNumber
          orderDate
          totalAmount
        }
      }
    }
  }
`;
